import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLang } from "@/i18n";

export default function SectorPage() {
  const { slug } = useParams();
  const { t } = useLang();
  const sector = t.sectors.items.find((s) => s.k === slug);

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [slug]);

  return (
    <main className="flex min-h-screen flex-col items-center justify-center px-6 text-center">
      <p className="overline mb-5">{t.sectors.overline}</p>
      <h1 className="font-serif text-4xl font-light text-white sm:text-5xl lg:text-6xl">
        {sector ? sector.t : slug}
      </h1>

      <Link
        to="/"
        className="mt-12 inline-flex items-center gap-2 border border-gold/50 px-6 py-3 text-xs uppercase tracking-[0.2em] text-gold transition-all duration-300 hover:bg-gold hover:text-ink"
      >
        <ArrowLeft size={16} /> {t.nav.about}
      </Link>
    </main>
  );
}
